<template>
  <v-card>
    <v-card-title class="headline"
      >Detalles
      <v-btn
        style="right: 10px; top: 10px"
        icon
        color="primary"
        fab
        absolute
        @click="$emit('cancel')"
      >
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="6" sm="3" md="3">
            <p class="mb-0 pb-0 font-weight-bold">Productos</p>
            <p>{{ opl.productsTotal | currency }}</p>
          </v-col>
          <v-col cols="6" sm="2" md="2">
            <p class="mb-0 pb-0 font-weight-bold">Envío</p>
            <p>{{ opl.deliveryCost | currency }}</p>
          </v-col>
          <v-col cols="6" sm="3" md="3">
            <p class="mb-0 pb-0 font-weight-bold">Estado del pago</p>
            <p>
              {{ opl.state | statusFilter }}
            </p>
          </v-col>
          <v-col v-if="opl.state == 'pending'" cols="6" sm="4" md="4">
            <p class="mb-0 pb-0 font-weight-bold">Fecha Vencimiento</p>
            <p>{{ opl.expiresAt | tsToDate }}</p>
          </v-col>

          <v-col v-if="opl.state == 'paid'" cols="6" sm="4" md="4">
            <p class="mb-0 pb-0 font-weight-bold">Pagado el</p>
            <p>{{ opl.paidAt | tsToDate }}</p>
          </v-col>

          <v-col cols="12" sm="12" md="12">
            <p class="mb-0 pb-0 font-weight-bold">Concepto</p>
            <p>{{ opl.description }}</p>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from "moment-timezone";
import "moment/locale/es";
moment.locale("es");
export default {
  props: ["opl"],
  name: "pay-link-details",

  methods: {},
  filters: {
    currency: function (amount) {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "HNL",
        minimumFractionDigits: 2,
      });
      return formatter.format(amount);
    },
    tsToDate: function (timestamp) {
      if (!timestamp) return "n/a";
      return moment(timestamp.toDate())
        .tz("America/Tegucigalpa")
        .format("DD/MM/YYYY  hh:mm A");
    },
    statusFilter: function (status) {
      switch (status) {
        case "paid":
          return "Pagado";
          break;

        case "pending":
          return "Pendiente";
          break;

        case "canceled":
          return "Cancelado";
          break;

        default:
          return status;
          break;
      }
    },
  },
};
</script>